module.exports = __webpack_public_path__ + "static/img/jieshao.61393c78.png";